import React from 'react';
import styled from 'styled-components';

type DeliveryProfitBadgeProps = {
  currentProfit: number;
  potentialLoss: number;
  profitInPercentage: number;
};

const DeliveryProfitBadge = ({ currentProfit, potentialLoss, profitInPercentage }: DeliveryProfitBadgeProps) => {
  return (
    <Wrapper>
      <ProfitValue $isProfit={currentProfit >= 0}>
       {currentProfit.toFixed(2)}{currentProfit >= 0 ? '+' : ''} ₪ ({profitInPercentage.toFixed(1)}%)
      </ProfitValue>
      
      <DeltaValue>
        {Math.abs(potentialLoss).toFixed(2)} ₪
      </DeltaValue>
    </Wrapper>
  );
};

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  gap: 0.25em;
  padding: 0.5em 0.75em;
  background: linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%);
  border-radius: 10px;
  border-right: 3px solid #297F76;
  font-family: 'Assistant', sans-serif;
`;

const ProfitValue = styled.div<{ $isProfit: boolean }>`
  font-size: 1.1em;
  font-weight: 700;
  color: ${props => props.$isProfit ? '#28a745' : '#dc3545'};
  direction: rtl;
`;

const DeltaValue = styled.div`
  font-size: 0.9em;
  font-weight: 600;
  padding: 0.25em 0.5em;
  border-radius: 6px;
  background: rgba(220, 53, 69, 0.15);
  color: #dc3545;
  direction: rtl;
`;

export default DeliveryProfitBadge;

